import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import type { JsonPostLocale } from "@/lib/blog/schema";
import { InlineText } from "./InlineText";

export function JsonFaq({ copy }: { copy: JsonPostLocale }) {
  if (!copy.faq.length) return null;
  return <section id="faq" className="scroll-mt-28">
    <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-foreground mb-6">{copy.faqTitle}</h2>
    <Accordion type="single" collapsible className="space-y-3">{copy.faq.map((item, i) => <AccordionItem key={i} value={`faq-${i}`} className="rounded-xl border border-border/60 bg-card/40 px-5 [&>[role=region][data-state=closed]]:hidden">
      <AccordionTrigger className="text-left font-semibold">{item.q}</AccordionTrigger>
      <AccordionContent forceMount className="text-base leading-relaxed text-muted-foreground"><InlineText text={item.a} /></AccordionContent>
    </AccordionItem>)}</Accordion>
  </section>;
}
export function JsonRelated({ copy }: { copy: JsonPostLocale }) {
  if (!copy.related.length) return null;
  return <section><h2 className="font-heading text-2xl font-bold text-foreground mb-5">{copy.relatedTitle}</h2>
    <div className="grid gap-3 sm:grid-cols-2">{copy.related.map((item, i) => {
      const children = <><span className="block font-semibold text-foreground"><InlineText text={item.label} /></span><span className="mt-1 block text-sm text-muted-foreground"><InlineText text={item.desc} /></span></>;
      const className = "rounded-xl border border-border/60 bg-card/40 p-4 hover:border-primary/40 transition-colors";
      return item.href.startsWith("/") ? <Link key={i} to={item.href} className={className}>{children}</Link> : <a key={i} href={item.href} target="_blank" rel="noopener noreferrer" className={className}>{children}</a>;
    })}</div>
  </section>;
}
export function JsonSources({ copy }: { copy: JsonPostLocale }) {
  if (!copy.sources.length) return null;
  return <section id="sources" className="border-t border-border/40 pt-8">
    <h2 className="font-heading text-2xl font-bold text-foreground mb-5">{copy.sourcesTitle}</h2>
    <ul className="space-y-4 text-sm text-muted-foreground break-words">{copy.sources.map((source, i) => <li key={i}>
      <a href={source.url} target="_blank" rel="noopener noreferrer" className="text-primary underline underline-offset-4">{source.label}</a>
      <span className="block mt-1">{source.publisher} · <time dateTime={source.accessed}>{source.accessed}</time></span>
    </li>)}</ul>
  </section>;
}
